import Lalamove from "./Lalamove"

export default Lalamove
